import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {Master} from '../../../../admin/models/master.interface';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {EditQuestionCategoriesComponent} from '../edit-question-categories/edit-question-categories.component';
import {CreateQuestionCategoriesComponent} from '../create-question-categories/create-question-categories.component';

@Component({
  selector: 'app-question-categories-table',
  templateUrl: './question-categories-table.component.html',
  styleUrls: ['./question-categories-table.component.scss']
})
export class QuestionCategoriesTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['description', 'edit'];

  @Input()
  questionCategories!: Master[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadQuestionCategories: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadQuestionCategories.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadQuestionCategories.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  addQuestionCategory(): void {
    const dialogRef = this.dialog.open(CreateQuestionCategoriesComponent, {maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.createEvent.subscribe(() => {
      this.loadQuestionCategories.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  editQuestionCategory(value: Master): void {
    const dialogRef = this.dialog.open(EditQuestionCategoriesComponent, {data: value, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.editEvent.subscribe(() => {
      this.loadQuestionCategories.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

}
